import { Layout } from '@coinscrap/webapp-core';
import { GlobalStyles } from 'styles/globalStyles';

export const BasicLayout = ({ children }) => (
  <Layout>
    <GlobalStyles />
    {children}
  </Layout>
);
